import React from 'react';
import { StatCard } from '../ui';

const RUNNING = new Set(['starting', 'running', 'finishing']);

export const FleetStrip: React.FC<{
  states: Record<string, { actualState?: string } | undefined>;
  ids?: string[]; // when given, only these (non-retired registry) ids are counted
}> = ({ states, ids }) => {
  const docs = (ids ? ids.map((id) => states[id]) : Object.values(states)).filter(Boolean) as { actualState?: string }[];
  const running = docs.filter((d) => RUNNING.has(d.actualState ?? '')).length;
  const errors = docs.filter((d) => d.actualState === 'crashed').length;
  const idle = docs.length - running - errors;
  return (
    <div className="pc-fleet">
      <StatCard value={running} label="Running" tone="success" />
      <StatCard value={errors} label="Errors" tone={errors > 0 ? 'error' : 'muted'} />
      <StatCard value={idle} label="Idle / stopped" tone="muted" />
    </div>
  );
};
